import React from "react";
import "../../../../../css/pages/ca_pages/teams/employees_model/EmployeePageHeader.css";

const EmployeePageHeader = ({ onAddEmployee }) => {
    return (
        <div className="employee-page-header">
            <div>
                <h1>Employees</h1>
                <p>Manage, monitor and track your firm's workforce.</p>
            </div>

            <button
                type      = "button"
                className = "employee-add-btn"
                onClick   = { onAddEmployee }
            >
                + Add Employee
            </button>
        </div>
    );
};

export default EmployeePageHeader;
